export default Object.freeze({
  QUIZ: 'quiz',
  SKILL: 'skill',
  PROJECT: 'project',
  MENTORING: 'mentoring',
  PRESENTATION: 'presentation',
  LEARNING_OUTCOME: 'learningOutcome',
});
